import React from 'react';
import { useTranslation } from 'react-i18next';

import { SgpIcon } from '@/components/SgpIcon';
import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useActiveSelectionCount } from '@/feature/betslip-sbk/hooks/betslip-hooks';
import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { ComboBetTypes } from '@/feature/betslip-sbk/types';
import { getComboBetType } from '@/feature/betslip-sbk/utils/betslip-utils';

export const ParlayTitle = () => {
    const { t } = useTranslation('bets');
    const activeSelectionCount = useActiveSelectionCount();
    const comboBetType = useSbkBetSlipStore(state => getComboBetType(state));

    const showSgpBadge = comboBetType === ComboBetTypes.SGP || comboBetType === ComboBetTypes.SGP_Plus;
    const isSgpPlus = comboBetType === ComboBetTypes.SGP_Plus;

    return (
        <Row alignItems="center" gap="s8">
            {showSgpBadge ? <SgpIcon isSgpPlus={isSgpPlus} /> : null}
            <Text variant="titleMedium" color={ds.colorToken.text.primary}>
                {t('parlay_bet_name', { count: activeSelectionCount })}
            </Text>
        </Row>
    );
};
